import PropTypes from "prop-types";
import ApiDescription from "./ApiDescription";
import tradingApiData from "./tableData";
import React from "react";

function TradingApi({ scrollRef, search }) {
  return (
    <div>
      <ApiDescription data={tradingApiData} search={search} />
    </div>
  );
}
TradingApi.propTypes = {
  scrollRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }).isRequired,
  search: PropTypes.string.isRequired,
};
export default TradingApi;
